import { ISagaModule } from "redux-dynamic-modules-saga";
import { missingSpacesEntitiesReducer } from "./state/missingSpacesSlice";
import { watchInitMenuSpace } from "./state/sagas/initMenuSpace";
import { loadCanViewSpaceWatcher } from "./state/sagas/loadCanViewSpace";
import { watchFetchMissingSpaces } from "./state/sagas/loadMissingSpaces";
import { watchSaveMenuSpaceSaga } from "./state/sagas/saveMenuSpace";
import { watchArchiveSpace } from "./state/sagas/watchArchiveSpace";
import { watchCreateSpace } from "./state/sagas/watchCreateSpace";
import { spacesReducer } from "./state/spacesSlice";
import { MissingSpacesState, SpacesState } from "./types";

export const getSpacesModule = (): ISagaModule<SpacesState> => ({
    id: "spaces",
    reducerMap: spacesReducer,
    sagas: [watchInitMenuSpace, watchCreateSpace, watchSaveMenuSpaceSaga, loadCanViewSpaceWatcher, watchArchiveSpace],
});

export const getMissingSpacesModule = (): ISagaModule<MissingSpacesState> => ({
    id: "missing_spaces",
    reducerMap: {
        missingSpaces: missingSpacesEntitiesReducer,
    },
    sagas: [watchFetchMissingSpaces],
});
